import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Button, Box, Text, useMultiStyleConfig} from '@chakra-ui/react'
import WebDrawer from '../../../../components/web-drawer'
import AddressDisplay from './address-display'

const NoCloseMatchDrawer = ({isOpen, onClose, enteredAddress}) => {
    const styles = useMultiStyleConfig('AddressValidationDrawer', {variant: 'noCloseMatch'})
    return (
    <WebDrawer
        noBodyStyle={true}
        isOpen={isOpen}
        onClose={() => onClose(false)}
        size="hug"
        headerInContent
        footer={
            <Button
                variant="webPrimary"
                w={'100%'}
                onClick={() => onClose(false)}
            >
                <FormattedMessage
                    defaultMessage="Edit Address"
                    id="shipping_address.modal.edit_address"
                />
            </Button>
        }
    >
        <Box {...styles.body}>
            <Text {...styles.title} mb={3}>
                <FormattedMessage
                    defaultMessage="Please double-check your address"
                    id="shipping_address.modal.double_check_address_title"
                />
            </Text>
            <Text {...styles.description} mb={5}>
                <FormattedMessage
                    defaultMessage="Your address cannot be verified. Unfortunately we cannot ship to this address."
                    id="shipping_address.modal.address_cannot_be_verified_text"
                />
            </Text>
            <Text {...styles.label} mb={3}>
                <FormattedMessage
                    defaultMessage="You Entered"
                    id="shipping_address.modal.entered_address"
                />
            </Text>
            <Box {...styles.addressDisplay}>
                <AddressDisplay address={enteredAddress} />
            </Box>
        </Box>
    </WebDrawer>
    )
}

NoCloseMatchDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    enteredAddress: PropTypes.object.isRequired
}

export default NoCloseMatchDrawer
